import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { FiEye } from "react-icons/fi"; // Import eye icon for view button

const FeedbackQuestions = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  // Static data for feedback types
  const staticData = [
    {
      id: 1,
      type: "Rating Section",
      description: "Questions with star ratings",
      path: "/feedback-questions/rating"
    },
    {
      id: 2,
      type: "MCQ Questions",
      description: "Multiple choice questions",
      path: "/feedback-questions/mcq"
    },
    {
      id: 3,
      type: "Like and Dislike Questions",
      description: "Thumbs up/down questions",
      path: "/feedback-questions/like-dislike"
    }
  ];

  const columns = [
    {
      name: "Question Type",
      selector: (row) => row.type,
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <button
          className="btn btn-link p-0"
          onClick={() => navigate(row.path)}
          style={{
            color: '#007bff',
            background: 'none',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          <FiEye size={18} /> View
        </button>
      ),
      center: true,
    },
  ];

  return (
    <>
      {isLoading ? (
        <div className="w-100 d-flex">
          <div className="spinner-border text-primary mx-auto" role="status"></div>
        </div>
      ) : (
        <div>
          <div className="page-header">
            <h3 className="page-title">Feedback Questions</h3>
          </div>
          <div className="row">
            <div className="col-lg-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body py-4">
                  <DataTable
                    columns={columns}
                    data={staticData}
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[
                      10, 20, 30, 50, 100, 200, 500,
                    ]}
                    highlightOnHover
                    pointerOnHover
                    responsive
                    striped
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FeedbackQuestions;